/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Input for searching logs in text index.
*/
export class SearchLogsInput {
  /**
  * The list of resource IDs to search logs for. Vault ID is extracted from the attached LLG policy.
  */
  'resourceIds': Array<string>;
  /**
  * Lucene syntax query string to search logs. Examples: \"level:error\", \"eventName:CreateUser AND userIdentity.type:IAMUser\" 
  */
  'query': string;
  /**
  * The start date for the search. Defaults to 30 days ago if not provided.
  */
  'startDate'?: Date;
  /**
  * The end date for the search. Defaults to now if not provided.
  */
  'endDate'?: Date;
  /**
  * The maximum number of records to return. Defaults to 100.
  */
  'pageSize'?: number;
  /**
  * Opaque pagination token from a previous response\'s nextToken. Pass this to fetch the next page.
  */
  'pageToken'?: string;
  /**
  * The restore account ID to use for Athena queries. Required for customer-owned vaults (BYOV). For Eon-managed vaults, this field is optional and will be ignored. 
  */
  'restoreAccountId'?: string;
  /**
  * The S3 bucket in the restore account for Athena query output. Required for customer-owned vaults (BYOV). For Eon-managed vaults, this field is optional and will be ignored. 
  */
  'restoreBucket'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "resourceIds",
      "baseName": "resourceIds",
      "type": "Array<string>",
      "format": "uuid"
    },
    {
      "name": "query",
      "baseName": "query",
      "type": "string",
      "format": ""
    },
    {
      "name": "startDate",
      "baseName": "startDate",
      "type": "Date",
      "format": "date-time"
    },
    {
      "name": "endDate",
      "baseName": "endDate",
      "type": "Date",
      "format": "date-time"
    },
    {
      "name": "pageSize",
      "baseName": "pageSize",
      "type": "number",
      "format": ""
    },
    {
      "name": "pageToken",
      "baseName": "pageToken",
      "type": "string",
      "format": ""
    },
    {
      "name": "restoreAccountId",
      "baseName": "restoreAccountId",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "restoreBucket",
      "baseName": "restoreBucket",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return SearchLogsInput.attributeTypeMap;
  }

  public constructor() {
  }
}

